const Configs = {
  EXPRESS_REVALIDATION_INTERVAL: 60, // 1 minute
  STANDARD_REVALIDATION_INTERVAL: 300, //5 minutes
  DEFERRED_REVALIDATION_INTERVAL: 300, // Switched to 5 minutes for testing
  IMPERSONATION_EXTEND_INTERVAL: 60,
  SITE_NAME: 'Amway',
  ROBOTS_REQUEST_RATE: '1/10',
  ROBOTS_CRAWL_DELAY: '10',
  ROBOTS_VISIT_TIME: '2130-0130',
  CONTENT_STACK_LIVE_PREVIEW_DOMAIN: 'https://app.contentstack.com/',
  AMSHOP_SERVICE_BASE_URL: 'http://localhost:8080',
  AMSHOP_SERVICE_BASE_URL_LOCAL: 'http://local-dev.amway-global.net:10000',
  WEBSHOP_FEATURE_FLAG_PROFILE_ID: 'webshop',
  CHANNEL: 'WEB',
  TEALIUM_ACCOUNT: 'amway',
  ADA_SCRIPT_SOURCE: 'https://static.ada.support/embed2.js',
  REQUEST_TIMEOUT: 15000,
  TENANT_NAME_KEY: 'TENANT_NAME',
  TENANT_ENV_KEY: 'TENANT_ENV',
  TENANT_CODE_KEY: 'tenantCode',
  NEXT_PUBLIC_DEV_API_URL: 'http://127.0.0.1:10000/api', // local development
  NEXT_SESSIONS_API_URL: '/comsessionps/v1/sessions', // local development
  FALLBACK_LANGUAGE: 'en-us',
  BONUS_HIGHEST_LEVEL: 21,
  COOKIE_POLICY_URL: '/landing/cookies-policy',
  CONTENT_STACK_CDN_URL: 'https://cdn.contentstack.io',
};

export default Configs;
